import type { PlannerID } from '@/types/app'
import type { APIEnv } from '@400f/frontend-constants'
import { resolveAPIEndpoints } from '@400f/frontend-constants'
import type { AppEnvironment } from './apis/infrastructures'

const resolveAPIEnv = (dolphinEnv: AppEnvironment): APIEnv => {
  switch (dolphinEnv) {
    case 'development':
    case 'test':
    case 'alpha':
      return 'alpha'
    default:
      return dolphinEnv
  }
}
const config = resolveAPIEndpoints(
  resolveAPIEnv(import.meta.env.MODE as AppEnvironment)
)
/* 🙈 localで立てたエンドポイントだけコメントアウト外して使う 🙉 */
// config.apis.federationGateway = 'http://localhost:8282' as any
if (!config) {
  throw new Error('config not found')
}

export const VERSION = process.env.APP_VERSION
export const COMMITTED_TIME =
  process.env.COMMITTED_TIME || '1970-01-01T00:00:00Z'

const isLocal = (host: string): boolean => /localhost/.test(host)
const isAlpha = (host: string): boolean => /local\.400f\.jp|alpha/.test(host)
const isDemo = (host: string): boolean => /demo/.test(host)

export const DOLPHIN_HOST = ((host: string) => {
  if (isLocal(host)) {
    return 'https://local.400f.jp:8888'
  }
  if (isAlpha(host)) {
    return 'https://dolphin.okane-kenko-alpha.jp'
  }
  if (isDemo(host)) {
    return 'https://dolphin-demo.400f.jp'
  }
  return 'https://fp.okane-kenko.jp'
})(document.location.host)

const createDolphinPath = (path: string): string =>
  new URL(path, DOLPHIN_HOST).toString()

export const getDolphinChatRoomOwnURL = (chatRoomID: string): string =>
  createDolphinPath(`/chat/own/${chatRoomID}`)

export const SHADOW_HOST = ((host: string) => {
  if (isLocal(host)) {
    return 'http://shadow.local.400f.jp'
  }
  if (isAlpha(host)) {
    return 'https://shadow.okane-kenko-alpha.jp'
  }
  if (isDemo(host)) {
    return 'https://shadow-demo.400f.jp'
  }
  return 'https://okane-kenko.jp'
})(document.location.host)

const createShadowPath = (path: string): string =>
  new URL(path, SHADOW_HOST).toString()

export const SHADOW_CONTACT_URL = createShadowPath(`/contact/`)
export const getShadowPlannerDetailURL = (plannerID: PlannerID): string =>
  createShadowPath(`/planner/${plannerID}`)

export const getShadowPlannerChatQRURL = (plannerID: PlannerID): string =>
  createShadowPath(`/redirect/planner/${plannerID}?inflow_source=qr`)

export const getShadowCalendarURL = (calendarGUID: string): string =>
  createShadowPath(`/calendar/${calendarGUID}`)

type APIName = keyof typeof config.apis
export const getAPIBaseURL = (apiName: APIName): string => {
  return config.apis[apiName]
}

export const createAPIPath = (apiName: APIName, path: string) => {
  const baseUrl = getAPIBaseURL(apiName)
  return `${baseUrl}${path}`
}

export const FAQ_URL = 'https://faq.fp.okane-kenko.jp/'

export class Config {
  static getConfig() {
    return config
  }
  static get isDevelopment(): boolean {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return config.env !== 'production'
  }
  static get isProduction(): boolean {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return config.env === 'production'
  }
}
